import { FeatureImpl } from './Feature';
import { Point } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Utils } from './Utils';
import { Icon, Style } from 'ol/style';
import { Feature as OLFeature } from 'ol';
export class AirportImpl extends FeatureImpl {
    constructor(data, config) {
        super(data, config);
        this._style = new Style({
            image: new Icon({
                anchor: [6.5, 6.5],
                anchorXUnits: 'pixels',
                anchorYUnits: 'pixels',
                src: this._config.city
            })
        });
        this._activeStyle = new Style({
            image: new Icon({
                src: this._config.cityActive
            })
        });
        this.routes = [];
    }
    create() {
        this.feature = new OLFeature({
            geometry: new Point(Utils.transformCoords([this.data.latitude, this.data.longitude]))
        });
        this.feature.setStyle(this.style);
        const vectorSource = new VectorSource({
            features: [this.feature]
        });
        this._layer = new VectorLayer({
            zIndex: 3,
            source: vectorSource
        });
        return this._layer;
    }
    isEqual(airport) {
        return this.data.iata === airport.data.iata;
    }
}
